import api from 'services/api'

export const login = ({username, password}) =>
    api.post('/token', {
        username: username,
        password: password
    })

